<template>
  <div
    class="tw-flex tw-w-full tw-max-w-full tw-cursor-pointer tw-items-center tw-text-grey-medium hover:tw-text-blackest"
  >
    <div class="tw-flex tw-items-center tw-gap-2 tw-truncate tw-text-xs">
      <div
        v-if="item.statusAi === 'Blacklisted'"
        class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded tw-bg-status-error tw-px-1 tw-py-px tw-text-2xs tw-text-white"
      >
        <Icon name="bot" />
        Blocked
      </div>
      <div
        v-else-if="item.statusAi === 'Whitelisted'"
        class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded tw-bg-status-success tw-px-1 tw-py-px tw-text-2xs tw-text-white"
      >
        <Icon name="bot" />
        Allowed
      </div>
      <div
        v-else
        class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded tw-bg-status-archived tw-px-1 tw-py-px tw-text-2xs tw-text-white"
      >
        <Icon
          name="spinner"
          class="tw-animate-spin"
        />
        Pending
      </div>
    </div>
  </div>
</template>
<script>
import Icon from '@/components/Icon.vue'
import ListCellDefault from '@/components/list/cell/default.vue'

export default {
  name: 'ListCellCreativeStatusAi',
  extends: ListCellDefault,
  components: {
    Icon,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
}
</script>
